"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themeConfigs = exports.getThemeConfig = void 0;
Object.defineProperty(exports, "themeNames", {
  enumerable: true,
  get: function get() {
    return _themeNames["default"];
  }
});
var _themeNames = _interopRequireDefault(require("./themeNames"));
var _upgrade = _interopRequireDefault(require("./themes/upgrade"));
var _dark = _interopRequireDefault(require("./themes/dark"));
var _universal = _interopRequireDefault(require("./themes/universal"));
var _themeConfigs;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var themeConfigs = (_themeConfigs = {}, _defineProperty(_themeConfigs, _themeNames["default"].UPGRADE_THEME_NAME, _upgrade["default"]), _defineProperty(_themeConfigs, _themeNames["default"].UPGRADE_DARK_THEME_NAME, _dark["default"]), _defineProperty(_themeConfigs, _themeNames["default"].UNIVERSAL_CREDIT_THEME_NAME, _universal["default"]), _themeConfigs);
exports.themeConfigs = themeConfigs;
var getThemeConfig = function getThemeConfig(themeName) {
  return themeName && themeConfigs[themeName] || _upgrade["default"];
};
exports.getThemeConfig = getThemeConfig;
//# sourceMappingURL=index.js.map